import { graphql } from "../gql";

export default graphql(`
  query getGameScores($input: OddsMarketTypesInput!) {
    event(input: $input) {
      scoreboard {
        firstQuarter {
          home
          away
        }
        secondQuarter {
          home
          away
        }
        thirdQuarter {
          home
          away
        }
        fourthQuarter {
          home
          away
        }
        overtime {
          home
          away
        }
        finalScore {
          home
          away
        }
        timeoutsRemaining {
          home
          away
        }
        timeoutsTotal
        clock
        possession
        isRedZone
      }
    }
  }
`);
